<template>
  <div class="index" v-show="isShow">
    <!-- 顶栏通告 -->
    <div class="wrapper">
      <div class="content">
        <div class="loading-icon-wrapper" v-show="isPullingDown">
          <svg-icon class="loading-icon" name="loading-dot"></svg-icon>
        </div>
        <Notify :status.sync="notify.status" :content="notify.content"></Notify>
        <!-- 顶部栏 -->
        <header class="header">
          <!-- 搜索 -->
          <Search-box
            class="search-box"
            ref="searchBox"
            @locate="locate"
            @search="search"
            @touchstart.prevent
            readonly="readonly"
            :placeholder="placeholder"
            :currentCity="currentCity"
            :hideScreen="hideScreenSearchBox"
          ></Search-box>
          <!-- 轮播图 -->
          <Swiper v-if="channel != '002_11_0000_0000_00'" ref="swiper"></Swiper>
          <!-- 首页导航 -->
          <Navigation :data="operation1" v-if="operation1 && operation1.length > 0"></Navigation>
        </header>
        <!-- 无套餐或机构时不显示 -->
        <template v-if="!noResult">
          <!-- 推荐机构 -->
          <RecommendHospital v-if="recommendOrgInfo" :orgInfo="recommendOrgInfo" />
          <!-- 精选体检 -->
          <HandpickPackage />
          <GroupBuy
            v-if="groupBuyList.length"
            :list="groupBuyList"
            :loadDone="loadDone"
            :isGroup="isGroup"
          ></GroupBuy>
          <!-- 套餐列表 -->
          <PackageListNew :list="packageList" :noMoreData="noMoreData"></PackageListNew>
          <!-- 资讯列表 -->
        </template>
        <!-- 无套餐或机构时提示用户 -->
        <NoResultIndex title="当前城市无可预约的机构或套餐" v-else @toCityList="toCityList"></NoResultIndex>

        <confirm
          ref="confirm"
          type="0"
          text="当前城市与定位城市不符，是否切换为定位城市？"
          confirmBtnText="确定"
          @confirm="toggleCity"
          @cancel="cancelCity"
        ></confirm>

        <confirm
          ref="confirm1"
          type="0"
          :text="locationNoDateText"
          confirmBtnText="确定"
          @confirm="confirmToggleCity"
          @cancel="cancelCity"
          btnLen="1"
        ></confirm>

        <Toast ref="toast" :pass1="toastOpt"></Toast>
        <!--版权声明-->
        <FooterExplain></FooterExplain>
        <!-- 通用弹窗 -->
        <transition name="fade" appear>
          <compositePopup
            v-if="showCompositePopup"
            @closeCompositePopup="closeCompositePopup"
            :data="compositePopupInfo"
          ></compositePopup>
        </transition>
        <!-- 智能助手 -->
      </div>
    </div>
    <img class="assistant" @click="assistant" src="../assets/images/assistant/i-assistant.png" />
    <!--固定导航-->
    <FixedNav :inx="0"></FixedNav>
  </div>
</template>

<script>
// 方法
import { mapActions, mapGetters } from "vuex";
import {
  http,
  HTTP_URL,
  getGroupBuyTopList,
  getRecommendHospital,
} from "@/assets/js/api";
import { newAddDistance, getUrlParams, addDistance } from "@/assets/js/util";
import { changeIndex } from "@/assets/js/miniapp";
import store from "@/store";
// 组件
import PackageListNew from "@/components/index/PackageListNew"; // 套餐列表
import SearchBox from "@/components/search/search-box"; // 搜索框
import Swiper from "@/components/index/Swiper"; // 轮播图
import Navigation from "@/components/index/Navigation"; // 首页导航
import RecommendHospital from "@/components/index/RecommendHospital"; // 推荐机构
import HandpickPackage from "@/components/index/HandpickPackage"; // 精选套餐
import TypeEntry from "@/components/index/TypeEntry"; // 快捷入口
import Shortcut from "@/components/common/Shortcut"; // 快捷入口
import GroupBuy from "@/components/index/GroupBuy";
import NoResultIndex from "@/components/no-result-index"; // 数据为空时提示
import FooterExplain from "@/components/common/footer-explain"; // 服务说明
import Notify from "@/components/index/Notify"; // 通知栏
import Toast from "@/components/toast"; // toast
import Confirm from "@/components/common/confirm";
import FixedNav from "@/components/common/FixedNav"; // 底部固定导航
import compositePopup from "@/components/common/compositePopup"; // 通用活动弹窗
import customerService from "@/assets/js/customerService";
import { comefromConfigObj, comefromLink } from "@/assets/js/comefrom";
// import BScroll from "better-scroll";
// import PackageList from "@/components/index/PackageList"; // 套餐列表
// import NewsList from "@/components/common/NewsList"; // 资讯列表
// import OrgList from "@/components/index/OrgList"; // 机构列表
// import Tab from "@/components/tab";                    // 底部导航
// import EntryCMB from "@/components/entry/EntryCMB"; // 招行活动弹窗
// import EntryShiYuShow from "@/components/entry/EntryShiYuShow"; // 招行活动弹窗
// import EntryJuneActivity1 from "@/components/entry/EntryJuneActivity1"; // 六月活动1
// import EntryJuneActivity2 from "@/components/entry/EntryJuneActivity2"; // 六月活动2

export default {
  name: "index",
  components: {
    PackageListNew,
    SearchBox,
    Swiper,
    Navigation,
    TypeEntry,
    Shortcut,
    Confirm,
    NoResultIndex,
    Toast,
    FixedNav,
    FooterExplain,
    Notify,
    compositePopup,
    GroupBuy,
    RecommendHospital,
    HandpickPackage,
  },
  data() {
    return {
      customerService,
      isShow: false,
      locationNoDateText: "",
      placeholder: "搜索体检机构或套餐",
      // sessionStorage.getItem("comefrom") == "health"
      //   ? "搜一搜，开启专业体检预约"
      //   : `专业预约体检，就上${brandConfig.companyName}`,
      loadDone: false, // 是否完成数据加载
      noResult: false,
      packageList: [], // 套餐列表数据
      groupBuyList: [], //  拼团列表
      isGroup: false,
      operation1: JSON.parse(newH5IndexProps.operation1) || [],
      operation2: JSON.parse(newH5IndexProps.operation2) || [],
      shortcut: JSON.parse(newH5IndexProps.operation3) || [],
      toastOpt: {
        title: "定位失败",
        icon: "fail",
        duration: 1500,
      },
      notify: {
        status: false,
        content: "",
      },
      hideScreenSearchBox: true,
      compositePopupInfo: {},
      showCompositePopup: true,
      recommendOrgInfo: null,
      completeSortPackageList: [],
      noMoreData: false,
      isPullingDown: false,
      channel: sessionStorage.getItem("channel")
    };
  },
  computed: {
    ...mapGetters(["currentCity", "user"]),
  },
  methods: {
    // initBScroll() {
    //   this.$nextTick(() => {
    //     this.bs = new BScroll(".wrapper", {
    //       click: true,
    //       pullUpLoad: true,
    //       pullDownRefresh: {
    //         stop: 0,
    //       },
    //       freeScroll: true,
    //       // bounce: {
    //       //   top: false,
    //       //   bottom: false,
    //       // },
    //     });
    //     console.log("初始化bs");
    //     this.bs.on("pullingDown", () => {
    //       if (this.isPullingDown) return;
    //       console.log("下拉刷新", this.isPullingDown);
    //       this.isPullingDown = true;
    //       this.load();
    //       this.getRecommendHospital();
    //     });
    //     this.bs.on("pullingUp", () => {
    //       console.log("上拉加载");
    //       if (this.noMoreData) return;
    //       if (this.completeSortPackageList.length > 10) {
    //         this.packageList = this.packageList.concat(
    //           this.completeSortPackageList.slice(0, 10)
    //         );
    //         this.completeSortPackageList.splice(0, 10);
    //       } else {
    //         this.packageList = this.orgList.concat(
    //           this.completeSortPackageList
    //         );
    //         this.completeSortPackageList = [];
    //         this.noMoreData = true;
    //         console.log("没有更多数据了。。。");
    //       }
    //       this.$nextTick(() => {
    //         this.bs.refresh(); // DOM 结构发生变化后，重新初始化BScroll
    //         this.bs.finishPullUp();
    //       });
    //     });
    //   });
    // },
    closeCompositePopup() {
      this.showCompositePopup = false;
    },
    clear() {
      localStorage.clear();
    },
    load() {
      var vm = this;
      if (!changeIndex(vm)) {
        return;
      }
      // 初始化时关闭无服务弹窗
      this.$refs.confirm1.hide();

      // 每次加载数据时，根据当前城市ID重新请求banner数据
      this.channel != '002_11_0000_0000_00' && this.$refs.swiper.getData(this.currentCity.city_id);
      Promise.all([
        // 精选套餐
        http({
          url: HTTP_URL.getWellChosenPackage,
          params: {
            city_id: this.currentCity.city_id,
          },
          prefix: API_PATH,
        }),

        // 活动弹窗
        http({
          url: HTTP_URL.homePopub,
          params: this.$route.query.composite_popup_id
            ? {
              composite_popup_id: this.$route.query.composite_popup_id,
            }
            : {},
          prefix: appPath,
        }),
        // 拼团活动
        getGroupBuyTopList({
          city_id: this.currentCity.city_id,
          channel: sessionStorage.getItem("channel"),
        }),
      ]).then((response) => {
        this.loadDone = true;
        addDistance(this, response[0].data)
          .then((arr) => {
            console.log("获取添加位置信息的数据1", arr);
            this.completeSortPackageList = this.sortOrgList(arr);
          })
          .catch((err) => {
            console.log("添加distance error信息", err);
            this.completeSortPackageList = response[0].data.sort((a, b) => {
              return b.sold_cnt - a.sold_cnt;
            });
          })
          .finally(() => {
            if (this.completeSortPackageList.length > 10) {
              this.packageList = this.completeSortPackageList.slice(0, 10);
              this.completeSortPackageList.splice(0, 10);
            } else {
              this.packageList = this.completeSortPackageList;
              this.completeSortPackageList = [];
              this.noMoreData = true;
            }
            this.groupBuyList = response[2].data.list;
            this.isGroup = response[2].data.all_count > 3;
            this.noResult = this.packageList.length === 0;
            if (response[1].code === 200) {
              // 活动弹窗
              this.compositePopupInfo = response[1].data;
            }
            // this.mockPopup()
            console.log('弹窗数据', this.compositePopupInfo)
            console.log("精选套餐列表", this.packageList);
            // this.$nextTick(()=>{
            //   this.initBScroll();
            // })
            if (this.isPullingDown) {
              this.isPullingDown = false;
              this.bs.finishPullDown();
            }
            newAddDistance(vm) // 定位
              .then(
                (res) => {
                  if (res !== true) {
                    // vm.showNoserver(response);
                  }
                },
                () => {
                  vm.showNoserver(response);
                }
              );
          });
      });
    },
    sortOrgList(data) {
      return data.sort((a, b) => {
        if (
          a.distance * 100 - b.distance * 100 >= 0 &&
          b.sold_cnt - a.sold_cnt > 0
        ) {
          return 1;
        } else if (a.distance * 100 - b.distance * 100 > 0) {
          return 1;
        }
        return -1;
      });
    },
    getRecommendHospital() {
      if (ENTRY_CHANNEL[this.channel] === "掌铁") {
        this.isShow = true;
        return;
      }
      const vm = this;
      const params = {
        city_id: this.currentCity.city_id,
      };

      if (sessionStorage.getItem("lon_lat")) {
        const lon_lat = sessionStorage.getItem("lon_lat").split(",");
        params.longitude = lon_lat[0];
        params.latitude = lon_lat[1];
      }
      getRecommendHospital(params).then(async (res) => {
        if (res.code === 200) {
          if (res.data.id) {
            this.recommendOrgInfo = res.data;
          } else {
            try {
              var res = await http({
                url: HTTP_URL.getOrgList,
                params: {
                  city_id: this.currentCity.city_id,
                  isHome: 1,
                },
              });
              var arr = await addDistance(this, res.data);
              this.recommendOrgInfo = {
                ...arr.sort((a, b) => {
                  return a.distance * 100 - b.distance * 100;
                })[0],
                data_flag: "old",
              };
            } catch (error) {
              vm.recommendOrgInfo = {
                ...res.data[0],
                data_flag: "old",
              };
            }
          }
          this.isShow = true;
        }
      });
    },
    // 无服务城市弹窗
    showNoserver(response) {
      if (!sessionStorage.getItem("showNoserver")) {
        sessionStorage.setItem("showNoserver", 1);
        this.confirmToggleCity();
        return;
      }

      if (
        response[0].data &&
        response[0].data.length < 1 &&
        this.currentCity.city_id != 200
      ) {
        // 当前城市无套餐
        this.locationNoDateText =
          "定位城市“" +
          this.currentCity.city_name +
          "”暂无服务，我们已加快步伐覆盖更多城市啦";
        this.$refs.confirm1.show();
      }
    },
    confirmToggleCity() {
      this.saveCity(defaultCityId_name);
      this.load();
    },
    // 到定位页面
    locate() {
      this.$router.push("/city-list");
    },
    // 到搜索页面
    search() {
      this.$baiDuMtaEvent(["个检/首页", `点击搜索`, "", "-"]); //数据上报
      this.$router.push("/search");
    },
    // 到城市列表页面
    toCityList() {
      this.$router.push("/city-list");
    },
    // 切换城市
    toggleCity() {
      var info = localStorage.getItem("myLocationInfo")
        ? JSON.parse(localStorage.getItem("myLocationInfo"))
        : "";
      if (info) {
        this.saveCity(info);
        this.load();
      }
    },
    changeIndex(next) {
      // alert( JSON.stringify(sessionStorage.getItem('orgEntryInfo')) )
      if (sessionStorage.getItem("orgEntryInfo")) {
        let info = JSON.parse(sessionStorage.getItem("orgEntryInfo"));
        next({
          name: "org-detail",
          params: {
            id: info.org_id,
          },
        });
        return false;
      }
      return true;
    },
    cancelCity() {
      // var info = localStorage.getItem('myLocationInfo') ? JSON.parse(localStorage.getItem('myLocationInfo')) : '';
      // if( info ) {
      //   this.saveCity({
      //     city_name: cityInfo.name,
      //     city_id: cityInfo.city_id,
      //     lon_lat:  info.lon_lat,
      //     date: Math.floor( new Date().getTime() / 1000 )
      //   })
      // }
      // this.load();
    },
    assistant() {
      customerService.link_to(this);
    },
    // mockPopup() {
    //   this.compositePopupInfo = {
    //     popub: {
    //         scene: "1",
    //         type: "1",
    //         closeBtnCss: "1",
    //         bgPicUrl: "https://public-10006067.file.myqcloud.com//upload/imagelist/thumb/0965a7983f4ec79f2ace9222f85ffb63.png",
    //         closeBtnPicUrl: "",
    //         buttons: [
    //             {
    //                 "btnType": "1",
    //                 "btnPicUrl": "https://public-10006067.file.myqcloud.com//upload/imagelist/ori/bd758931a9078cbbf1db91537dbe0cc6.png",
    //                 "btnUrl": "https://apps.dsjkyy.com/wechat/h5#/common-activity/211"
    //             }
    //         ]
    //     }
    //   }
    // },
    ...mapActions({
      setCcbDiscount: "SET_CCB_DISCOUNT",
      saveCity: "saveCity",
    }),
  },
  beforeRouteEnter(to, from, next) {
    // 有第三方信息就直接跳转到第三方首页
    if (comefromLink("home")) {
      return;
    } else if (taifuli == 1) {
      // 泰福利身份跳转泰福利首页
      // next(vm => {
      //   vm.$router.replace({
      //     name: "tai-welfare"
      //   });
      // });
      next({
        name: "tai-welfare",
      });
    } else if (third_party_user && third_party_user != "0") {
      // 第三方用户跳转定制化首页
      next({
        name: "third-party",
      });
    } else if (isFamilyDoctor) {
      // 医生卡跳医生卡首页
      let comefromConfig = comefromConfigObj();
      window.location.replace(`${comefromConfig.health.prefix}health/#/home`);
      // next({
      //   name: "doctor-card-home",
      // });
    } else if (getUrlParams(window.location.href)["to"] === "org-list") {
      var token = getUrlParams(window.location.href)["miniappToken"];
      getUrlParams(window.location.href)["channel"] &&
        sessionStorage.setItem(
          "channel",
          getUrlParams(window.location.href)["channel"]
        );
      if (token) {
        localStorage.setItem("miniappToken", token);
      }
      next({
        name: "orgListV2",
      });
    } else {
      next((vm) => {
        vm.setCcbDiscount(false);
      });
    }
  },
  activated() {
    this.bs && this.bs.refresh();
    changeIndex(this);
  },
  created() {
    if (localStorage.getItem("myLocationInfo")) {
      localStorage.removeItem("myLocationInfo");
    }
    // 埋点,有query则请求接口
    if (Object.keys(this.$route.query).length) {
      http({
        url: HTTP_URL.tracing,
        method: "post",
      });
    }
    this.$nextTick(() => {
      this.load();
    });
    // 通知栏状态内容
    if (window.newH5IndexProps.homePageNotify.content) {
      (this.notify.status = true),
        (this.notify.content = window.newH5IndexProps.homePageNotify.content);
    }
    // this.load();
    this.getRecommendHospital();
    this.$baiDuMtaEvent(["个检/首页", `访问页面`, "", "-"]); //数据上报
  },
  watch: {
    "currentCity.city_id"() {
      this.bs && this.bs.destroy();
      this.load();
      this.getRecommendHospital();
    },
  },
};
</script>

<style lang="less" scoped>
@image: "../assets/images/";

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.index {
  background: #f8f9fa;

  .loading-icon-wrapper {
    display: flex;
    padding: 26/200rem 0;
    align-items: center;
    justify-content: center;
    .loading-icon {
      width: 48/200rem;
      height: 48/200rem;
    }
  }

  .wrapper {
    // height: calc(100vh - 0.37rem);
    // overflow: hidden;
    height: calc(100vh - 0.50rem);
    overflow-y: scroll;
    .content {
      padding-bottom: 64/200rem;
    }
  }

  .header {
    background-color: #fff;
  }

  .popup-activity-entry {
    z-index: 8888;
  }

  .shortcut {
    margin-top: 14/200rem;
  }

  .navigation {
    padding-top: 10/200rem;
  }

  .org-list {
    padding: 20/200rem 0 50/200rem;
  }

  .type-entry {
    padding: 45/200rem 0 10/200rem 0;
  }

  .news-list {
    padding-bottom: 45/200rem;
  }

  .no-result-index {
    margin-top: -30/200rem;
  }

  .notify-body-wrap {
    z-index: 2000;
  }

  .assistant {
    position: fixed;
    width: 0.5rem;
    height: 0.5rem;
    // bottom: 1.2rem;
    top: 4.83rem;
    // top: 5rem;
    right: 0.1rem;
    object-fit: contain;
    z-index: 100;
  }
}

@media only screen and (max-width: 320px) {
  .assistant {
    width: 0.4rem !important;
    height: 0.4rem !important;
    top: 4.5rem !important;
    right: 0.1rem !important;
  }
}
</style>
